import { Command } from 'commander';
import { ApiClient } from '../client.js';
import { formatOutput } from '../output.js';
import { parseData, getDatabase, getFormat } from '../helpers.js';
const VALID_PROVIDERS = 'openai, anthropic, google, mcp';

export const providersCommand = new Command('providers')
  .description('Import/export tool definitions between LLM providers and Record collections');

providersCommand.command('import <provider>')
  .description(`Import tool definitions as collections. Providers: ${VALID_PROVIDERS}`)
  .requiredOption('--tools <json>', 'Tool definitions (inline JSON or @filename)')
  .action(async function (this: Command, provider: string, opts: { tools: string }) {
    const ws = getDatabase(this);
    const client = new ApiClient();
    const tools = parseData(opts.tools);
    const data = await client.request('POST', `/v1/${ws}/providers/${provider}/import`, {
      tools: Array.isArray(tools) ? tools : [tools],
    });
    console.log(formatOutput(data, getFormat(this)));
  });

providersCommand.command('export <provider>')
  .description(`Export collections as tool definitions. Providers: ${VALID_PROVIDERS}`)
  .option('--collections <ids>', 'Comma-separated collection IDs (omit for all)')
  .option('--output <file>', 'Write output to file')
  .action(async function (this: Command, provider: string, opts: { collections?: string; output?: string }) {
    const ws = getDatabase(this);
    const client = new ApiClient();
    const query = opts.collections ? `?collections=${opts.collections}` : '';
    const data = await client.request('GET', `/v1/${ws}/providers/${provider}/export${query}`);

    if (opts.output) {
      const { writeFileSync } = await import('fs');
      writeFileSync(opts.output, JSON.stringify(data, null, 2));
      console.log(`Written to ${opts.output}`);
    } else {
      console.log(formatOutput(data, getFormat(this)));
    }
  });

providersCommand.command('import-call <provider> <collection>')
  .description(`Create a document from a tool call in provider format. Providers: ${VALID_PROVIDERS}`)
  .requiredOption('--data <json>', 'Tool call data in provider format (inline JSON or @filename)')
  .option('--external-id <id>', 'External ID for idempotent upsert')
  .option('--external-source <source>', 'External source identifier')
  .action(async function (this: Command, provider: string, collection: string, opts: { data: string; externalId?: string; externalSource?: string }) {
    const ws = getDatabase(this);
    const client = new ApiClient();
    const callData = parseData(opts.data);
    const queryParts: string[] = [];
    if (opts.externalId) queryParts.push(`external_id=${encodeURIComponent(opts.externalId)}`);
    if (opts.externalSource) queryParts.push(`external_source=${encodeURIComponent(opts.externalSource)}`);
    const qs = queryParts.length ? `?${queryParts.join('&')}` : '';
    const data = await client.request('POST', `/v1/${ws}/providers/${provider}/documents/${collection}${qs}`, callData);
    console.log(formatOutput(data, getFormat(this)));
  });
